import { render, staticRenderFns } from "./homeBox.vue?vue&type=template&id=59ec9291&scoped=true"
import script from "./homeBox.vue?vue&type=script&lang=js"
export * from "./homeBox.vue?vue&type=script&lang=js"
import style0 from "./homeBox.vue?vue&type=style&index=0&id=59ec9291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec9291",
  null
  
)

export default component.exports